// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","icons":"Footer_icons__3k_Xg","icon":"Footer_icon__ISVxC","courtosy":"Footer_courtosy__e3Iky"};